import { useSelector } from 'react-redux';

export const useCanAddCampaign = () => {
  const { accessibility } = useSelector((state) => state.shop);
  return accessibility?.canAddCampaign;
};
